import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../../commonFields";

export const filterPanelBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Filter panel",
  canHaveChildren: false,
  noWrap: true,
  inputs: [
    {
      name: "filterVariant",
      type: "enum",
      enum: ["index", "search"],
      defaultValue: "index",
      localized: false,
    },
    {
      name: "alwaysDisplayed",
      type: "boolean",
      helperText:
        "Enable this toggle if the filter panel should be always displayed. If disabled, the panel is displayed only after a filter is selected.",
      defaultValue: false,
      localized: false,
      required: false,
    },
    {
      name: "noResultsFoundText",
      type: "string",
      localized: true,
      required: true,
    },
    {
      name: "loadingText",
      type: "string",
      localized: true,
      required: true,
    },
    {
      name: "singularResultFoundText",
      type: "string",
      localized: true,
      required: true,
      helperText:
        "Label used when there is only one result. Use the {COUNT} variable to indicate the result count. Ex.: 'Showing {COUNT} result'",
    },
    {
      name: "resultsFoundText",
      type: "string",
      localized: true,
      required: true,
      helperText:
        "Use the {COUNT} variable to indicate the results count. Ex.: 'Showing {COUNT} results'",
    },
    {
      name: "clearAll",
      type: "object",
      subFields: [
        {
          name: "text",
          type: "string",
          localized: true,
          required: true,
          defaultValue: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Clear all",
          },
        },
        DLD_FIELD,
        DLT_FIELD,
      ],
    },
    {
      name: "withBottomLine",
      type: "boolean",
      localized: false,
      required: false,
      defaultValue: false,
    },
  ],
};
